import React, { useState } from "react";
import "./Navbar.css";
import { useNavigate, NavLink } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import {
  IconButton,
  Menu,
  MenuItem,
  Drawer,
  Box,
  Avatar,
  Divider,
  ListItemIcon,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import dashboardIcon from "../../assets/svgImages/dashboardIcon.svg";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import { BrandLogo } from "components/Flowstate";

const NavbarLoggedIn = () => {
  const navigate = useNavigate(); // Use the useNavigate hook
  const [showNavbar, setShowNavbar] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Implement your logout logic here
  const handleLogout = () => {
    localStorage.setItem("access_token", ""); // Clear the access token
    localStorage.setItem("token_expiration", "0"); // Set token expiration to 0
    handleClose();
    navigate("/flowstate"); // Back to the public homepage
  };

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setIsDrawerOpen(open);
  };

  const drawerContent = (
    <Box
      sx={{
        width: 250,
        backgroundColor: "#0172A6",
        height: "100%",
        padding: "16px",
        color: "#fff",
      }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <Box sx={{ marginBottom: "16px" }}>
        <BrandLogo size="medium" isLight={false} to="/flowstate" />
      </Box>
      <List>
        <ListItem button onClick={() => navigate("/dashboard")}>
          <img src={dashboardIcon} alt="Dashboard" style={{ marginRight: "8px", width: "18px" }} />
          <ListItemText primary="Dashboard" />
        </ListItem>
        <ListItem button onClick={() => navigate("/chat")}>
          <ChatBubbleOutlineOutlinedIcon sx={{ color: "white", marginRight: "8px" }} />
          <ListItemText primary="Chat" />
        </ListItem>
      </List>
    </Box>
  );

  return (
    <nav className="navbar">
      <div className="container-loggedIn w-100">
        {/* Menu Icon for Drawer */}
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={toggleDrawer(true)} // Open drawer on click
          sx={{
            position: "relative",
            left: 0,
            top: 0,
            zIndex: 1300,
            color: "rgb(134, 134, 134)",
          }}
        >
          <MenuIcon />
        </IconButton>

        {/* Drawer Implementation */}
        <Drawer
          anchor="left"
          open={isDrawerOpen}
          onClose={toggleDrawer(false)}
          BackdropProps={{
            style: { backgroundColor: "rgba(0, 0, 0, 0)" }, // Transparent backdrop
          }}
        >
          {drawerContent}
        </Drawer>

        <BrandLogo size="large" isLight={true} to="/flowstate" />

        <div className="menu-icon" onClick={handleShowNavbar}>
          <AccountCircleIcon />
        </div>

        <div className={`nav-elements ${showNavbar && "active"}`}>
          <ul>
            <li>{/* <NavLink to="/">Home</NavLink> */}</li>
            <li>{/* <NavLink to="/blog">Blog</NavLink> */}</li>
            <li>{/* <NavLink to="/projects">Projects</NavLink> */}</li>
            <li>{/* <NavLink to="/about">About</NavLink> */}</li>
            <li>{/* <NavLink to="/contact">Contact</NavLink> */}</li>
            <li>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                  position: "absolute",
                  top: 0,
                  right: "40px",
                }}
              >
                <IconButton
                  onClick={(event) => setAnchorEl(event.currentTarget)}
                  size="small"
                  sx={{ ml: 2 }}
                  aria-controls={open ? "account-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                >
                  <AccountCircleIcon />
                </IconButton>
              </Box>
              <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&::before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem onClick={handleClose} component={NavLink} to="/profile">
                  <Avatar /> Profile
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleClose}>
                  <ListItemIcon>
                    <Settings fontSize="small" />
                  </ListItemIcon>
                  Settings
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  Logout
                </MenuItem>
              </Menu>
            </li>
            <div
              className="d-flex justify-content-center position-absolute navbuttons"
              style={{ right: "16px" }}
            ></div>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavbarLoggedIn;
